module.exports = __webpack_public_path__ + "img/img22.78719db4.svg";